var _defs, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAslMiniBadgeFeatured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradMini",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f766e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#14b8a6"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#gradMini)",
    stroke: "#14b8a6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 18l4 8 9 1-7 6 2 9-8-4-8 4 2-9-7-6 9-1 4-8z",
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 54,
    textAnchor: "middle",
    fontFamily: "Inter, sans-serif",
    fontSize: 10,
    fontWeight: 700,
    fill: "#ffffff"
  }, "F")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAslMiniBadgeFeatured);
export default __webpack_public_path__ + "static/media/ASL_MiniBadge_Featured.542d3ce35ab55875e1d321f5504bee94.svg";
export { ForwardRef as ReactComponent };